import { bizDelete, bizGet, bizPost, bizPatch } from '../../shared/api/bizClient';
import type {
  PolicyDocument,
  PolicyEvaluationRecord,
  PolicyLifecycleAction,
  PolicyOverrideFormValues,
  PolicyRecord,
  PolicyTenantOverride,
  SimulatorResult,
} from './types';

const BASE_PATH = '/biz/admin/policies';

export async function listPolicies(): Promise<PolicyRecord[]> {
  return bizGet<PolicyRecord[]>(BASE_PATH);
}

export async function getPolicy(policyId: string): Promise<PolicyRecord | null> {
  return bizGet<PolicyRecord>(`${BASE_PATH}/${policyId}`);
}

export async function listEvaluations(policyId: string): Promise<PolicyEvaluationRecord[]> {
  return bizGet<PolicyEvaluationRecord[]>(`${BASE_PATH}/${policyId}/evaluations`);
}

export async function listOverrides(policyId: string): Promise<PolicyTenantOverride[]> {
  return bizGet<PolicyTenantOverride[]>(`${BASE_PATH}/${policyId}/overrides`);
}

export async function updatePolicyDocument(
  policyId: string,
  document: PolicyDocument,
): Promise<PolicyRecord> {
  return bizPatch<PolicyRecord, PolicyDocument>(`${BASE_PATH}/${policyId}`, document);
}

export async function applyLifecycle(
  policyId: string,
  action: PolicyLifecycleAction,
  reason: string,
): Promise<PolicyRecord> {
  return bizPost<PolicyRecord, { action: PolicyLifecycleAction; reason: string }>(
    `${BASE_PATH}/${policyId}/lifecycle`,
    { action, reason },
  );
}

export async function createOverride(
  policyId: string,
  values: PolicyOverrideFormValues,
): Promise<PolicyTenantOverride> {
  return bizPost<PolicyTenantOverride, PolicyOverrideFormValues>(
    `${BASE_PATH}/${policyId}/overrides`,
    values,
  );
}

export async function revokeOverride(policyId: string, overrideId: string): Promise<void> {
  await bizDelete<void>(`${BASE_PATH}/${policyId}/overrides/${overrideId}`);
}

export async function simulatePolicy(
  policyId: string,
  contextJson: string,
): Promise<SimulatorResult> {
  return bizPost<SimulatorResult, { contextJson: string }>(
    `${BASE_PATH}/${policyId}/simulate`,
    { contextJson },
  );
}
